import { UUID } from "../generic/uuid";
import { RegionDto } from "@vini-wine/core-dtos";

export interface RegionModel extends UUID {
  // transform
  name: string;
}

export const createRegionDtoFromAnalyticRegionModel = (
  region: RegionModel,
): RegionDto => {
  return {
    uuid: region.uuid,
    name: region.name,
  };
};
